import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { passQuestion } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { useMyServiceContext } from '../..';
import browserLanguage from 'Utility/browserLanguage';
import { useAppSelector } from 'Store/index';

export const PassQuestion = (): React.JSX.Element => {
  const locale = useAppSelector(s => s.settings.userSettings.uiLanguage) ?? browserLanguage;
  const { editing, setEditingData, viewing, setViewingObj, setEditingObj, fm } = useMyServiceContext<'passQuestion'>();
  const passQuestionData = editing?.data ?? viewing?.data ?? {};
  const passQuestionLocales = passQuestion.localizations;

  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    if (!field) return;
    const value = Object.values(values)[0];
    setEditingData?.({
      ...passQuestionData,
      [field]: value,
    });
  };

  return (
    <>
      <BlockWrapper
        title={viewing ? formatPartialDate(passQuestionData.date) : undefined}
        buttons={
          viewing
            ? [
                {
                  title: 'general.edit',
                  onClick: () => {
                    setViewingObj(null);
                    setEditingObj({ type: 'passQuestion', data: passQuestionData });
                  },
                },
              ]
            : undefined
        }
      >
        {!viewing && (
          <FormRow title={'general.date'}>
            <InputHandler
              name="date"
              type="PartialDate"
              dateDefault="now"
              formData={{
                document: { date: passQuestionData.date },
                onChange: onChangeSurveyForm,
              }}
              editing={!!editing}
            />
          </FormRow>
        )}
        <FormRow title={passQuestionLocales[locale]['satisfiedWithCurrentSituationPatient']} formatTitle={false}>
          <InputHandler
            type="Radio"
            name="satisfiedWithCurrentSituation"
            editing={!!editing}
            formData={{
              document: { satisfiedWithCurrentSituation: passQuestionData.satisfiedWithCurrentSituation },
              onChange: onChangeSurveyForm,
            }}
            options={['yes', 'no']}
            optionFormatter={o => fm(`general.${o}`)}
          />
        </FormRow>
      </BlockWrapper>
    </>
  );
};
